<script setup lang="ts">
import t from "~/utils/translate";
import { mdiChevronUp } from "@mdi/js";
import { Race, Racer } from "~/types/racing/race-details";
import { Outcome } from "~/types/uk/event-details";
import Ratings from "~/components/layout/TrackRacing/Shared/Ratings.vue";
interface TimeFormProps {
	race: Race;
	racers: Racer[];
	outcomes: Outcome[];
}

const props = defineProps<TimeFormProps>();
const active = ref(false);

const ratingsWithOutcomesId = computed(() => {
	const ratingsWithOutcomeId = props.race.StarRating.map((rating) => ({
		...rating,
		outcomeId: props.racers.find((racer) => racer.RacerId === rating.RacerId)?.OutcomeIds[0],
	}));
	return ratingsWithOutcomeId;
});
const starRatings = computed(() => {
	return ratingsWithOutcomesId.value.map((rating) => ({
		...rating,
		betName: props.outcomes.find((outcome) => outcome.Id === rating.outcomeId)?.BetName,
	}));
});
</script>

<template>
	<UiAccordion :activeIndex="1" :class="['overflow-hidden mt-2 rounded-lg']" @tab-open="active = true" @tab-close="active = false">
		<UiAccordionTab
			:headerWrapperClass="'w-full leading-none flex items-center h-9 gap-1 text-xs font-bold bg-light-50 dark:bg-dark-700 text-dark-500 dark:text-light-50 relative pr-10 p-2  overflow-hidden'"
			:disableToggle="false"
		>
			<template #header>
				<div class="truncate text-xs">
					<span v-if="active">{{ t("race-time-form") }}</span>
					<span class="font-light" v-else> {{ race.TimeFormPreviewTypeLong }}</span>
				</div>
			</template>
			<template #header-icon>
				<div class="absolute -translate-y-1/2 right-1 top-1/2 border border-light-500 dark:border-dark-500 rounded-md mr-1">
					<UiIcon :class="['z-10 w-7 h-7 fill-dark-500 dark:fill-light-50 transition-all', { 'rotate-180': !active }]" :path="mdiChevronUp" />
				</div>
			</template>
			<div class="px-3 py-1 text-xs bg-light-50 dark:bg-dark-700 leading-tight" v-if="active">
				{{ race.TimeFormPreviewTypeLong }}
				<div class="my-2">
					<div
						v-for="(outcome, index) in starRatings"
						:class="index + 1 !== starRatings?.length ? 'border-b border-b-light-500 dark:border-b-dark-500' : 'overflow-hidden'"
					>
						<div class="flex justify-between items-center py-2">
							<span class="font-bold">
								{{ outcome.betName }}
							</span>
							<Ratings v-if="outcome.Rating" :ratings="outcome.Rating" />
						</div>
					</div>
				</div>
			</div>
		</UiAccordionTab>
	</UiAccordion>
</template>
